/**
 * Chat-store state changes used by more than one store module — the action
 * object, conversation loading, and summarize polling. Plain functions over
 * the shared state (`chatStore.internal`), so those modules depend on this
 * one instead of on each other.
 */
import { getState, makeId, setState } from './chatStore.internal.js';
import type { SummarizeJob } from './chatStore.types.js';

/** Append an error row and end the turn. */
export function addError(message: string): void {
  const s = getState();
  setState({ ...s, messages: [...s.messages, { id: makeId(), role: 'error', content: message }], isStreaming: false });
}

/**
 * Append a centered informational system note. Unlike addError this does NOT
 * end the turn — it can arrive mid-stream (e.g. the summarize fallback note)
 * while the assistant is still generating.
 */
export function addSystemNotice(content: string): void {
  const s = getState();
  setState({ ...s, messages: [...s.messages, { id: makeId(), role: 'system', content }] });
}

export function setSummarizeJob(summarizeJob: SummarizeJob | null): void {
  setState({ ...getState(), summarizeJob });
}
